import React from "react";
import { motion } from "framer-motion";
import I18n from "i18n-js";

const ClearButton = ({ disabled, onClick }) => {

  return (
    <motion.button
      key="clear"
      aria-label={I18n.t("common.actions.clear")}
      className="clear-button"
      initial={{ opacity: 0, scale: 0.7 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.7 }}
      transition={{ duration: 0.15 }}
      disabled={disabled}
      onClick={onClick}
    >
      ✕
    </motion.button>
  );
}

export default ClearButton;
